/* eslint-disable */
import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

import {Storage} from './storage';

export const ALIAS_VARIABLE_ARRAY = [
    ['mens-eyeglasses', 'viewed_men'],
    ['men', 'viewed_men'],
    ['womens-eyeglasses', 'viewed_women'],
    ['women', 'viewed_women'],
    ['full-frames', 'viewed_full_frame'],
    ['full_name', 'viewed_full_frame'],
    ['designer-glasses', 'viewed_designer'],
    ['sports-glasses', 'viewed_sports'],
    ['prescription-sunglasses', 'viewed_sunglasses'],
    ['discounted-eyeglasses', 'viewed_clearance'],
    ['clearance', 'viewed_clearance'],
    ['progressive-lenses', 'viewed_multifocal'],
    ['bifocal_progressive', 'viewed_multifocal'],
    ['computer-glasses', 'viewed_computer'],
];

export class DirectAdd {
    options = {};
    storage = new Storage('jStorage');

    constructor(options = {}) {
        Object.assign(this.options, options);

        const searchParams = this.getSearchParams();
        const now = new Date().setHours(0, 0, 0, 0);
        const currentDate = this.brontoDateToDate(this.getCurrentVisitDate());
        const MS_IN_DAY = 86400000;

        if (currentDate.getTime() <= now - MS_IN_DAY) {
            this.setLastVisitDate(DirectAdd.dateToBrontoDate(currentDate));
        }

        this.setCurrentVisitDate(DirectAdd.dateToBrontoDate(new Date()));

        this.setCurrentLocation();

        const sourceMedium =
            (searchParams['utm_source'] || '') + '/' + (searchParams['utm_medium'] || '');

        if (sourceMedium !== '/') {
            if (this.get('first_source_medium')) {
                this.set('first_source_medium', sourceMedium);
            } else {
                this.set('last_soure_medium', sourceMedium);
            }
        }
    }

    setCurrentLocation() {
        ALIAS_VARIABLE_ARRAY.forEach(alias => {
            if (location.pathname.indexOf(alias[0]) === 1) {
                this.set(alias[1], DirectAdd.dateToBrontoDate(new Date()));
            }
        });
    }

    getSearchParams() {
        const searchParams = {};
        location.search
            .slice(1)
            .split('&')
            .forEach(paramString => {
                const param = paramString.split('=');
                searchParams[param[0]] = param[1];
            });

        return searchParams;
    }

    isDataChanged() {
        return this.isChanged;
    }

    keys() {
        return this.storage.index();
    }

    _buildData() {
        return this.keys().reduce((data, key) => {
            const value = this.get(key);

            if (typeof value === 'string') {
                Object.assign(data, {[key]: value});
            }
            return data;
        }, {});
    }

    _convertToFormData(data) {
        const formData = new FormData();

        Object.keys(data).forEach(key => formData.append(key, data[key]));

        return formData;
    }

    _generateDirectImage(imageId, imageSrc) {
        const directImage = document.createElement('img');
        directImage.id = imageId;
        directImage.width = 0;
        directImage.height = 0;
        directImage.src = imageSrc;
        directImage.ariaHidden = true;
        return directImage;
    }

    saveData(force = false) {
        if (this.isDataChanged() === false) {
            return this;
        }

        const buildedData = this._buildData();
        this.isChanged = false;

        if (this.get('email')) {
            instanceGusaBackend.post(ENDPOINTS.BRONTO_REPORT, this._convertToFormData(buildedData));

            return this;
        }

        let directUpdateImage = document.getElementById('direct-update');

        if (directUpdateImage !== null && directUpdateImage.tagName === 'IMG') {
            if (force) {
                directUpdateImage.parentElement.removeChild(directUpdateImage);
            } else {
                return this;
            }
        }

        return this;
    }

    static dateToBrontoDate(date) {
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        if (day < 10) day = `0${day}`;
        if (month < 19) month = `0${month}`;

        return `${month}/${day}/${year}`;
    }

    brontoDateToDate(brontoDate) {
        const dateArray = brontoDate.split('/');

        return new Date(dateArray[2], dateArray[0] - 1, dateArray[1], 0, 0, 0, 0);
    }

    setAffiliate(value) {
        this.set('affid', value);
        if (!this.get('first_affid')) {
            this.set('first_affid', value);
        }
        return this;
    }

    setCurrentVisitDate(date) {
        this.set('curr_visit', date);
        return this;
    }

    getCurrentVisitDate() {
        if (!this.get('curr_visit')) {
            return DirectAdd.dateToBrontoDate(new Date());
        }
        return this.get('curr_visit');
    }

    setLastVisitDate(date) {
        this.set('last_visit', date);
        return this;
    }

    getLastVisitDate() {
        if (!this.get('last_visit')) {
            return this.getCurrentVisitDate();
        }
        return this.get('last_visit');
    }

    set(key, value) {
        if (this.storage.get(key) !== value) {
            this.isChanged = true;
        }
        this.storage.set(key, value);
        return this;
    }

    get(key) {
        return this.storage.get(key);
    }

    unset(key) {
        this.isChanged = true;
        this.storage.unset(key);
        return this;
    }

    clear() {
        this.isChanged = true;
        this.storage.clear();
        return this;
    }
}
